module.exports = __webpack_public_path__ + "static/media/Snapshot Vid Script June_1594156617693.64caa83d.docx";